import uuid from 'uuid/v1';

export default [
  {
    id: uuid(),
    title: 'ฎีกาเงินเดือน 4109',
    description:
      'เงินเดือนพนักงานในสถาบันอุดมศึกษา',
    imageUrl: '/images/products/Report_1.png',
    totalDownloads: 'ดาวน์โหลดรายงาน ประจำเดือน',
    updatedAt: '27/03/2019',
    report_type_id: '4109-1'
  },
  {
    id: uuid(),
    title: 'ฎีกาเงินเดือน 4109',
    description:
      'เงินประจำตำแหน่งสายวิชาการ',
    imageUrl: '/images/products/Report_1.png',
    totalDownloads: 'ดาวน์โหลดรายงาน ประจำเดือน',
    updatedAt: '27/03/2019',
    report_type_id: '4109-2'
  },
  {
    id: uuid(),
    title: 'ฎีกาเงินเดือน 4109',
    description:
      'เงินประจำตำแหน่งผู้บริหาร',
    imageUrl: '/images/products/Report_1.png',
    totalDownloads: 'ดาวน์โหลดรายงาน ประจำเดือน',
    updatedAt: '27/03/2019',
    report_type_id: '4109-3'
  },
  {
    id: uuid(),
    title: 'ฎีกาเงินเดือน 4109',
    description:
      'เงินประจำตำแหน่งตกเบิกผู้บริหาร',
    imageUrl: '/images/products/Report_1.png',
    totalDownloads: 'ดาวน์โหลดรายงาน ประจำเดือน',
    updatedAt: '27/03/2019',
    report_type_id: '4109-31'
  },
  {
    id: uuid(),
    title: 'บก. 26',
    description:
      'แบบ บก. 26 ใบแนบฎีกาแสดงรายการ ภาษีเงินได้หัก ณ ที่จ่าย',
    imageUrl: '/images/products/Report_1.png',
    totalDownloads: 'ดาวน์โหลดรายงาน ประจำเดือน',
    createdAt: '31/03/2019',
    report_type_id: 'บก. 26'
  },
  {
    id: uuid(),
    title: 'พมล. ปกส.ด้านสังคม',
    description:
      'หน้างบการเบิก - จ่ายเงินประกันสังคมของพนักงานมหาวิทยาลัย ด้านสังคม',
    imageUrl: '/images/products/Report_1.png',
    totalDownloads: 'ดาวน์โหลดรายงาน ประจำเดือน',
    createdAt: '03/04/2019',
    report_type_id: 'พมล. ปกส'
  },
  {
    id: uuid(),
    title: 'สรุปรายงานลูกจ้าง',
    description:
      'สรุปรายงานประจำเดือนลูกจ้างชั่วคราวเดือนรายวัน มหาวิทยาลัยราชภัฏสกลนคร',
    imageUrl: '/images/products/Report_1.png',
    totalDownloads: 'ดาวน์โหลดรายงาน ประจำเดือน',
    createdAt: '04/04/2019',
    report_type_id: '4109-7'
  }/*,
  {
    id: uuid(),
    title: 'GitHub',
    description:
      'GitHub is a web-based hosting service for version control of code using Git.',
    imageUrl: '/images/products/Report_1.png',
    totalDownloads: '835',
    createdAt: '04/04/2019'
  },
  {
    id: uuid(),
    title: 'Squarespace',
    description:
      'Squarespace provides software as a service for website building and hosting. Headquartered in NYC.',
    imageUrl: '/images/products/Report_1.png',
    totalDownloads: '835',
    createdAt: '04/04/2019'
  }*/
];
